import { ParentProps, createEffect } from "solid-js";
import { AccordionItem } from "./fragments/AccordionItem";
import { AccordionContext, AccordionProvider } from "./AccordionContext";

export class AccordionProps {
    multiple?: boolean;
    disabled?: boolean;
}

export default function Accordion(props: AccordionProps & ParentProps) {
    const context = new AccordionContext();

    createEffect(() => {
        context.receiveProps(props);
    })

    return (
        <AccordionProvider value={context}>
            <div>
                {props.children}
            </div>
        </AccordionProvider>
    )
}

Accordion.Item = AccordionItem;

Accordion.defaultProps = new AccordionProps();